import { combineEpics, ofType } from 'redux-observable';
import { pluck, switchMap } from 'rxjs/operators';

import { Epic } from 'src/config/rootEpic';

import {
    fetchProgramSurveyFail,
    fetchProgramSurveySuccess,
    fetchSeveralProgramSurveysFail,
    fetchSeveralProgramSurveysSuccess,
    FETCH_PROGRAM_SURVEY_REQUESTED,
    FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
    submitProgramSurveyFail,
    submitProgramSurveySuccess,
    submitSeveralProgramSurveysFail,
    submitSeveralProgramSurveysSuccess,
    SUBMIT_PROGRAM_SURVEY_REQUESTED,
    SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
} from '../actions/surveysActions';
import {
    FetchSeveralProgramSurveysData,
    FetchSurveyData,
    SubmitProgramSurveyData,
    SubmitSeveralProgramSurveysData,
} from '../models/surveys';
import { SurveysService } from '../services/SurveysService';

export function surveysEpicFactory(surveysService: SurveysService): Epic {
    const fetchProgramSurveyEpic: Epic = action$ =>
        action$.pipe(
            ofType(FETCH_PROGRAM_SURVEY_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: FetchSurveyData) =>
                    surveysService
                        .fetchProgramSurvey(data)
                        .then(fetchProgramSurveySuccess)
                        .catch(fetchProgramSurveyFail), // TODO: Inform user about error with toasts
            ),
        );

    const fetchSeveralProgramSurveysEpic: Epic = action$ =>
        action$.pipe(
            ofType(FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: FetchSeveralProgramSurveysData) =>
                    surveysService
                        .fetchSeveralProgramSurveys(data)
                        .then(fetchSeveralProgramSurveysSuccess)
                        .catch(fetchSeveralProgramSurveysFail), // TODO: Inform user about error with toasts
            ),
        );

    const submitProgramSurveyEpic: Epic = action$ =>
        action$.pipe(
            ofType(SUBMIT_PROGRAM_SURVEY_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: SubmitProgramSurveyData) =>
                    surveysService
                        .submitProgramSurvey(data)
                        .then(submitProgramSurveySuccess)
                        .catch(submitProgramSurveyFail), // TODO: Inform user about error with toasts
            ),
        );

    const submitSeveralProgramSurveysEpic: Epic = action$ =>
        action$.pipe(
            ofType(SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED),
            pluck('payload'),
            switchMap(
                (data: SubmitSeveralProgramSurveysData) =>
                    surveysService
                        .submitSeveralProgramSurveys(data)
                        .then(submitSeveralProgramSurveysSuccess)
                        .catch(submitSeveralProgramSurveysFail), // TODO: Inform user about error with toasts
            ),
        );

    return combineEpics(
        fetchProgramSurveyEpic,
        fetchSeveralProgramSurveysEpic,
        submitProgramSurveyEpic,
        submitSeveralProgramSurveysEpic,
    );
}
